module.exports = __webpack_public_path__ + "img/transfer.83cb28a5.svg";